import { render, staticRenderFns } from "./bottom-right.vue?vue&type=template&id=5b884096&"
import script from "./bottom-right.vue?vue&type=script&lang=js&"
export * from "./bottom-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports